import { LocalDate } from '../../../utilities/local-date';

export function calendariumWeeks(year: string) {
  const weeks: { name: string; count: number }[] = [];
  let day = LocalDate.fromString(year + '-01-01');
  while (day.year() === Number(year)) {
    const week = day.isoWeek();
    const count = day.daysOfWeekWithinYear();
    let name = '';
    if (count > 2) {
      name = 'uke ' + week;
    }
    weeks.push({
      name: name,
      count: count,
    });
    day = day.plusWeeks(1);
  }
  return weeks;
}
